import { LanguageCode } from 'translations/Language'
import { PricingLinks } from 'constants/staticLinks'

export const getPricingUrl = (language: string) => {
  switch (language) {
    case LanguageCode.EN:
      return PricingLinks.EN
    case LanguageCode.FR:
      return PricingLinks.FR
    case LanguageCode.DE:
      return PricingLinks.DE
    case LanguageCode.ES:
      return PricingLinks.ES
    case LanguageCode.NL:
      return PricingLinks.NL
    default:
      return PricingLinks.ALL_PURPOSE
  }
}
